export default __webpack_public_path__ + "static/media/06.d33d807c.png";